<script setup>
import { defineProps} from "vue";
import UtilMoney from "@utils/UtilMoney";
import NotaFiscalService from "@/api/v2/services/NotaFiscalService";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "parcela",
    "notaFiscalEmitida",
]);

//==================================================================//
//=================== Pega Nota Fiscal Emitida =====================//
//==================================================================//

const baixarNotaFiscalEmitida = async ()=>{

    let notaFiscalResponse = await NotaFiscalService.getNotaFiscalByPlugNotasId({
        nomeArquivo: props?.notaFiscalEmitida?.chaveAcesso,
        plugNotasId: props?.notaFiscalEmitida?.plugNotasID
    });
    if(notaFiscalResponse.status != "200"){
        throw new Error(`${notaFiscalResponse.message}`)
    }

};

</script>

<template>

    <div
        class="c-table__row"
    >

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <v-tooltip bottom>

                    <template v-slot:activator="{ on, attrs }">

                        <v-btn
                            class="c-baixar-nota-fiscal-emitida mx-2"
                            fab
                            dark
                            small
                            color="#3E737B"
                            v-bind="attrs"
                            v-on="on"
                            @click="baixarNotaFiscalEmitida"
                        >

                            <v-icon dark>
                                mdi-download
                            </v-icon>
                        
                        </v-btn>

                    </template>

                    <span>
                        Baixar Nota Fiscal Emitida
                    </span>

                </v-tooltip>

                <v-chip
                    color="#dedede"
                    label
                    dark
                >

                    <v-icon left color="#565656">
                        mdi-cash-multiple
                    </v-icon>

                    <span
                        class="c-table__cell-content-text"
                    >
                        {{props?.notaFiscalEmitida?.numero}}
                    </span>
                    

                </v-chip>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.notaFiscalEmitida?.contaAReceberCodigo}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.notaFiscalEmitida?.contaFinanceiraNome}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.notaFiscalEmitida?.recebimentoSequencia}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.notaFiscalEmitida?.recebimentoDataCriacao}}

            </div>

        </div>
                
        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.notaFiscalEmitida?.recebimentoValorRecebido)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content"></div>

        </div>

    </div>

</template>

<style scoped>

.c-table__row{
    display: contents;
}

.c-table__row:hover > .c-table__cell{
    background-color: #f0f0f0;
}

.c-table__cell{
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 13px 16px;
    font-size: 0.875rem;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.c-table__cell-content-text{
    color: #565656;
    font-weight: 600;
}

</style>
